App.factory('zochaSalaryBillService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function ZochaSalaryBillService() {
        this.dataList = function(data) {
            return baseService.post(Config.API_URL + '/zocha/salaryBill/list', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.getFile = function(id) {
            return baseService.download(Config.API_URL + '/zocha/salaryBill/' + id + '/download').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };
    }
    return new ZochaSalaryBillService();
}]);